
import Vue from 'vue'
import Router from 'vue-router'
Vue.use(Router);

const children: any[] = [];

const pluginContainer = {
  path: '/MainManage',
  name: 'MainManage',
  redirect: '/MainManage/index',
  component: () => import('../components/MainManage.vue'),
  children: children
};

const routes = [
  {
    path: '/', //登录
    name: 'Login',
    component: () => import('@/components/Login.vue')
  },

  {
    path: '/MainManage', //后台管理
    name: 'MainManage',
    component: () => import('@/components/MainManage.vue')
  },
  {
    path: '/index', //后台管理
    name: 'index',
    component: () => import('@/components/IOTPanl/index.vue')
  },
  //   {
  //   path: '/index', //goViewPro测试
  //   name: 'index',
  //   component: () => import('@/components/IOTPanl/index.vue')
  // },
];

export default new Router({
  routes: routes
});
